import { render, staticRenderFns } from "./LinkBoxControl.vue?vue&type=template&id=2aa8828e&scoped=true&"
import script from "./LinkBoxControl.vue?vue&type=script&lang=ts&"
export * from "./LinkBoxControl.vue?vue&type=script&lang=ts&"
import style0 from "./LinkBoxControl.vue?vue&type=style&index=0&id=2aa8828e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8828e",
  null
  
)

export default component.exports